import React, { Fragment, useEffect, useState } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { useSelector } from 'Hooks';
import { useI18n } from 'Hooks';
import {
  GET_ACCOUNT_HOLDERS,
  GET_ITEMS,
  GET_MENUS,
  GET_VENUES,
} from 'Scenes-redesign/Onboarding/queries';
import { getQueryData } from 'utils/getQueryData';

import { BarText, BarWrapper, Line, Step, StepCircle, Wrapper } from './styles';

export const OnboardingBar = () => {
  const { t } = useI18n();
  const history = useHistory();
  const location = useLocation();
  const companyId = useSelector((state) => state.company!);
  const userRole = useSelector((state) => state.userRole!);
  const [show, setShow] = useState(false);

  const accountHoldersData = getQueryData(GET_ACCOUNT_HOLDERS, companyId);
  const itemsData = getQueryData(GET_ITEMS, companyId);
  const menusData = getQueryData(GET_MENUS, companyId);
  const venuesData = getQueryData(GET_VENUES, companyId);

  const accountHolders = accountHoldersData.data?.company.adyenAccountHolders || [];
  const articles = itemsData.data?.getItems.results || [];
  const menus = menusData.data?.menus || [];
  const venues = venuesData.data?.venues || [];

  const visibleVMCategories = accountHoldersData.data?.company.visibleVMCategories;

  const steps = [
    {
      pathId: 'payments',
      name: t('General.Payments'),
      status: accountHolders.length > 0 ? 'PASSED' : 'TODO',
    },
    {
      pathId: accountHolders.length > 0 ? `payouts?id=${accountHolders[0]?.id}` : 'payouts',
      name: t('General.Payouts'),
      status: 'TODO',
    },
    {
      pathId: 'products',
      name: t('General.Products'),
      status: articles.length > 0 ? 'PASSED' : 'TODO',
    },
    { pathId: 'menus', name: t('General.Menu'), status: menus.length > 1 ? 'PASSED' : 'TODO' },
    { pathId: 'venues', name: t('General.Venues'), status: venues.length > 0 ? 'PASSED' : 'TODO' },
  ];

  useEffect(() => {
    if (
      userRole === 'CONTENT_ADMIN' &&
      location.pathname !== '/pos' &&
      visibleVMCategories?.includes('onboarding-beta')
    ) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [userRole, visibleVMCategories, location]);

  const handleStepClick = (pathId) => {
    history.push(`/onboarding-beta/${pathId}`);
  };

  if (show) {
    return (
      <Wrapper>
        <BarWrapper>
          {steps.map(({ pathId, name, status }, index) => (
            <Fragment key={pathId}>
              <Step onClick={() => handleStepClick(pathId)}>
                <StepCircle content={name} status={status} />
              </Step>
              {index < steps.length - 1 && <Line status={steps[index + 1].status} />}
            </Fragment>
          ))}
        </BarWrapper>
      </Wrapper>
    );
  }
  return null;
};
